/* ─────────────────────────────────────────────────────────────────────────
   codeEditorShared.js
   Tema, dil algılama ve PHP IntelliSense/formatter için paylaşılan
   sabitler ve yardımcı fonksiyonlar.
   FlowChartCodeEditorPanel ve FloatingCodeEditor tarafından kullanılır.
───────────────────────────────────────────────────────────────────────── */

/* ── Cursor / GitHub Dark Monaco teması ── */
export const CURSOR_DARK_THEME = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: 'comment',                foreground: '8b949e', fontStyle: 'italic' },
    { token: 'comment.line',           foreground: '8b949e', fontStyle: 'italic' },
    { token: 'comment.block',          foreground: '8b949e', fontStyle: 'italic' },
    { token: 'keyword',                foreground: 'ff7b72' },
    { token: 'keyword.control',        foreground: 'ff7b72' },
    { token: 'keyword.operator',       foreground: 'ff7b72' },
    { token: 'storage',                foreground: 'ff7b72' },
    { token: 'string',                 foreground: 'a5d6ff' },
    { token: 'string.double',          foreground: 'a5d6ff' },
    { token: 'string.single',          foreground: 'a5d6ff' },
    { token: 'string.heredoc',         foreground: 'a5d6ff' },
    { token: 'string.escape',          foreground: '79c0ff' },
    { token: 'string.quoted',          foreground: 'a5d6ff' },
    { token: 'string.template',        foreground: 'a5d6ff' },
    { token: 'number',                 foreground: '79c0ff' },
    { token: 'number.hex',             foreground: '79c0ff' },
    { token: 'constant.numeric',       foreground: '79c0ff' },
    { token: 'constant.language',      foreground: '79c0ff', fontStyle: 'italic' },
    { token: 'constant',               foreground: '79c0ff' },
    /* PHP-spesifik token'lar */
    { token: 'variable.php',           foreground: 'ffa657' },
    { token: 'variable',               foreground: 'e6edf3' },
    { token: 'variable.parameter',     foreground: 'ffa657' },
    { token: 'variable.other',         foreground: 'e6edf3' },
    { token: 'entity.name.function',   foreground: 'd2a8ff' },
    { token: 'support.function',       foreground: '79c0ff' },
    { token: 'entity.name.class',      foreground: 'ffa657' },
    { token: 'entity.name.type',       foreground: 'ffa657' },
    { token: 'support.class',          foreground: 'ffa657' },
    { token: 'type',                   foreground: 'ffa657' },
    { token: 'operator',               foreground: 'ff7b72' },
    { token: 'delimiter',              foreground: 'c9d1d9' },
    { token: 'delimiter.bracket',      foreground: 'c9d1d9' },
    { token: 'metatag',                foreground: '7ee787', fontStyle: 'bold' },
    { token: 'tag',                    foreground: '7ee787' },
    { token: 'tag.id',                 foreground: '7ee787' },
    { token: 'attribute.name',         foreground: 'ffa657' },
    { token: 'attribute.value',        foreground: 'a5d6ff' },
    { token: 'regexp',                 foreground: 'a5d6ff' },
    { token: 'namespace',              foreground: 'ffa657' },
    { token: 'annotation',             foreground: 'd2a8ff' },
  ],
  colors: {
    'editor.background':                    '#0d1117',
    'editor.foreground':                    '#e6edf3',
    'editorGutter.background':              '#0d1117',
    'editorLineNumber.foreground':          '#484f58',
    'editorLineNumber.activeForeground':    '#cdd9e5',
    'editorCursor.foreground':              '#79c0ff',
    'editorCursor.background':              '#0d1117',
    'editor.selectionBackground':           '#264f78',
    'editor.inactiveSelectionBackground':   '#264f7855',
    'editor.selectionHighlightBackground':  '#264f7835',
    'editor.lineHighlightBackground':       '#161b22',
    'editor.lineHighlightBorder':           '#21262d',
    'editorWhitespace.foreground':          '#30363d',
    'editorIndentGuide.background1':        '#21262d',
    'editorIndentGuide.activeBackground1':  '#484f58',
    'editor.findMatchBackground':           '#ffa65755',
    'editor.findMatchBorder':               '#ffa657',
    'editor.findMatchHighlightBackground':  '#ffa65725',
    'editor.wordHighlightBackground':       '#1f6feb30',
    'editor.wordHighlightStrongBackground': '#1f6feb50',
    'editorWidget.background':              '#161b22',
    'editorWidget.border':                  '#30363d',
    'editorWidget.foreground':              '#e6edf3',
    'editorSuggestWidget.background':       '#161b22',
    'editorSuggestWidget.border':           '#30363d',
    'editorSuggestWidget.foreground':       '#e6edf3',
    'editorSuggestWidget.selectedBackground': '#1f6feb40',
    'editorSuggestWidget.highlightForeground': '#79c0ff',
    'editorHoverWidget.background':         '#161b22',
    'editorHoverWidget.border':             '#30363d',
    'editorHoverWidget.foreground':         '#e6edf3',
    'scrollbarSlider.background':           '#484f5840',
    'scrollbarSlider.hoverBackground':      '#484f5870',
    'scrollbarSlider.activeBackground':     '#484f5890',
    'minimap.background':                   '#0d1117',
    'minimap.selectionHighlight':           '#264f78',
    'editorBracketMatch.background':        '#1f6feb30',
    'editorBracketMatch.border':            '#388bfd',
    'editorOverviewRuler.border':           '#21262d',
    'diffEditor.insertedTextBackground':    '#23863633',
    'diffEditor.removedTextBackground':     '#da363333',
    'editorError.foreground':               '#0d1117',
    'editorError.border':                   '#0d1117',
    'editorWarning.foreground':             '#0d1117',
    'editorWarning.border':                 '#0d1117',
    'editorInfo.foreground':                '#0d1117',
    'editorInfo.border':                    '#0d1117',
  },
};

/* ── Uzantı → Monaco dil ID ── */
export const EXT_TO_LANG = {
  php: 'php', js: 'javascript', jsx: 'javascript',
  ts: 'typescript', tsx: 'typescript',
  html: 'html', htm: 'html',
  css: 'css', scss: 'scss', less: 'less',
  json: 'json', xml: 'xml', sql: 'sql',
  sh: 'shell', bash: 'shell',
  py: 'python', rb: 'ruby',
  yml: 'yaml', yaml: 'yaml', md: 'markdown',
};

export const LANG_STYLE = {
  php:        { color: '#a78bfa', bg: '#7c3aed18', border: '#7c3aed35' },
  javascript: { color: '#fbbf24', bg: '#f59e0b18', border: '#f59e0b35' },
  typescript: { color: '#60a5fa', bg: '#3b82f618', border: '#3b82f635' },
  html:       { color: '#f97316', bg: '#ea580c18', border: '#ea580c35' },
  css:        { color: '#34d399', bg: '#10b98118', border: '#10b98135' },
  scss:       { color: '#f472b6', bg: '#ec489918', border: '#ec489935' },
  json:       { color: '#a3e635', bg: '#84cc1618', border: '#84cc1635' },
  sql:        { color: '#38bdf8', bg: '#0ea5e918', border: '#0ea5e935' },
  python:     { color: '#fbbf24', bg: '#f59e0b18', border: '#f59e0b35' },
  shell:      { color: '#4ade80', bg: '#22c55e18', border: '#22c55e35' },
  xml:        { color: '#fb923c', bg: '#f9731618', border: '#f9731635' },
};

export function detectLang(filename) {
  if (!filename) return 'php';
  const ext = (filename.split('.').pop() || '').toLowerCase();
  return EXT_TO_LANG[ext] || 'php';
}

/* ── PHP completions ── */
export const PHP_KEYWORDS = [
  'echo', 'print', 'return', 'if', 'else', 'elseif', 'while', 'for', 'foreach', 'do',
  'switch', 'case', 'default', 'break', 'continue', 'function', 'class', 'interface',
  'trait', 'extends', 'implements', 'new', 'null', 'true', 'false', 'try', 'catch',
  'finally', 'throw', 'use', 'namespace', 'public', 'protected', 'private', 'static',
  'abstract', 'final', 'var', 'const', 'array', 'list', 'match', 'fn', 'yield',
  'require', 'include', 'require_once', 'include_once', 'isset', 'unset', 'empty',
  'die', 'exit', 'global', 'self', 'parent', '__construct', '__destruct',
];

export const PHP_SNIPPETS = [
  { label: 'if',       insert: 'if ($1) {\n\t$2\n}',                           doc: 'if block' },
  { label: 'ifelse',   insert: 'if ($1) {\n\t$2\n} else {\n\t$3\n}',           doc: 'if/else block' },
  { label: 'foreach',  insert: 'foreach ($1 as $2) {\n\t$3\n}',                doc: 'foreach loop' },
  { label: 'for',      insert: 'for ($i = 0; $i < $1; $i++) {\n\t$2\n}',       doc: 'for loop' },
  { label: 'while',    insert: 'while ($1) {\n\t$2\n}',                         doc: 'while loop' },
  { label: 'function', insert: 'function $1($2) {\n\t$3\n}',                   doc: 'function declaration' },
  { label: 'class',    insert: 'class $1 {\n\tpublic function __construct($2) {\n\t\t$3\n\t}\n}', doc: 'class' },
  { label: 'try',      insert: 'try {\n\t$1\n} catch (Exception $e) {\n\t$2\n}', doc: 'try/catch' },
  { label: 'switch',   insert: 'switch ($1) {\n\tcase $2:\n\t\t$3\n\t\tbreak;\n\tdefault:\n\t\t$4\n}', doc: 'switch' },
];

export const PHP_FUNCTIONS = [
  'str_replace', 'strlen', 'substr', 'strpos', 'strrpos', 'strtolower', 'strtoupper',
  'trim', 'ltrim', 'rtrim', 'str_pad', 'str_repeat', 'str_split', 'str_word_count',
  'ucfirst', 'lcfirst', 'ucwords', 'nl2br', 'wordwrap',
  'explode', 'implode', 'join', 'array_push', 'array_pop', 'array_shift', 'array_unshift',
  'array_merge', 'array_keys', 'array_values', 'array_map', 'array_filter', 'array_reduce',
  'array_search', 'array_splice', 'array_slice', 'array_chunk', 'array_flip', 'array_unique',
  'array_reverse', 'array_combine', 'array_diff', 'array_intersect', 'in_array', 'count',
  'json_encode', 'json_decode', 'serialize', 'unserialize',
  'sprintf', 'printf', 'number_format', 'round', 'ceil', 'floor', 'abs', 'max', 'min',
  'rand', 'mt_rand', 'sqrt', 'pow',
  'sort', 'rsort', 'asort', 'arsort', 'ksort', 'krsort', 'usort',
  'preg_match', 'preg_match_all', 'preg_replace', 'preg_split', 'preg_quote',
  'date', 'time', 'strtotime', 'mktime', 'microtime',
  'file_get_contents', 'file_put_contents', 'file_exists', 'is_file', 'is_dir',
  'fopen', 'fclose', 'fread', 'fwrite', 'fgets', 'feof',
  'mkdir', 'rmdir', 'unlink', 'rename', 'copy', 'glob',
  'header', 'ob_start', 'ob_get_clean', 'ob_end_clean',
  'session_start', 'session_destroy', 'setcookie',
  'htmlspecialchars', 'htmlentities', 'strip_tags', 'addslashes', 'stripslashes',
  'urlencode', 'urldecode', 'base64_encode', 'base64_decode',
  'md5', 'sha1', 'hash', 'password_hash', 'password_verify',
  'var_dump', 'print_r', 'var_export',
  'class_exists', 'method_exists', 'function_exists',
  'is_array', 'is_string', 'is_int', 'is_float', 'is_numeric', 'is_null', 'is_bool',
  'is_object', 'is_callable', 'intval', 'strval', 'floatval', 'boolval',
  'array_key_exists', 'compact', 'extract',
  'mysqli_connect', 'mysqli_query', 'mysqli_fetch_assoc', 'mysqli_close',
  'PDO', 'PDOException',
];

/* Singleton disposables — sadece bir kez kayıt */
let _phpCompletionDisposable = null;
let _phpFormatterDisposable  = null;
let _phpTokenizerRegistered  = false;
let _themeRegistered         = false;

export function registerEditorAssets(monaco) {
  /* 1. Tema */
  if (!_themeRegistered) {
    monaco.editor.defineTheme('cursor-dark', CURSOR_DARK_THEME);
    _themeRegistered = true;
  }

  /* 2. JS/TS diagnostics kapat */
  if (monaco.languages.typescript) {
    const opts = { noSemanticValidation: true, noSyntaxValidation: true, noSuggestionDiagnostics: true };
    monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions(opts);
    monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions(opts);
  }

  /* 3. PHP özel Monarch tokenizer — syntax renklendirme */
  if (!_phpTokenizerRegistered) {
    _phpTokenizerRegistered = true;
    try {
      monaco.languages.setMonarchTokensProvider('php', {
        defaultToken: '',
        tokenPostfix: '.php',
        ignoreCase: true,
        keywords: PHP_KEYWORDS,
        builtins: PHP_FUNCTIONS,
        tokenizer: {
          root: [
            [/<\?php\b|<\?=?/, { token: 'metatag', next: '@phpCode' }],
            [/[^<]+/, 'text'],
            [/</, 'text'],
          ],
          phpCode: [
            [/\?>/, { token: 'metatag', next: '@pop' }],
            // Comments
            [/\/\/.*$/, 'comment.line'],
            [/#.*$/, 'comment.line'],
            [/\/\*/, { token: 'comment.block', next: '@blockComment' }],
            // Strings
            [/"/, { token: 'string.double', next: '@dstring' }],
            [/'/, { token: 'string.single', next: '@sstring' }],
            // Heredoc (basit)
            [/<<<([a-zA-Z_]\w*)/, { token: 'string.heredoc.delimiter', next: '@heredoc' }],
            // Numbers
            [/\b0x[\da-fA-F]+\b/, 'number.hex'],
            [/\b\d+(\.\d+)?([eE][+-]?\d+)?\b/, 'number'],
            // Variables
            [/\$[a-zA-Z_]\w*/, 'variable.php'],
            // Class/interface/trait names after keywords
            [/(?<=(class|interface|trait|extends|implements|new)\s+)[A-Z]\w*/, 'entity.name.class'],
            // Function calls — identifier followed by (
            [/[a-zA-Z_]\w*(?=\s*\()/, {
              cases: {
                '@keywords': 'keyword',
                '@builtins': 'support.function',
                '@default': 'entity.name.function',
              },
            }],
            // Regular identifiers & keywords
            [/[a-zA-Z_]\w*/, {
              cases: {
                '@keywords': 'keyword',
                '@default': 'identifier',
              },
            }],
            // Brackets & delimiters
            [/[{}()\[\]]/, 'delimiter.bracket'],
            [/[;,]/, 'delimiter'],
            [/\./, 'delimiter'],
            // Operators
            [/->|=>|::|===|!==|==|!=|<=|>=|&&|\|\||\?\?/, 'operator'],
            [/[+\-*\/%=!<>&|^~?:]/, 'operator'],
            // Whitespace
            [/\s+/, ''],
          ],
          blockComment: [
            [/\*\//, { token: 'comment.block', next: '@pop' }],
            [/[^*]+/, 'comment.block'],
            [/\*(?!\/)/, 'comment.block'],
          ],
          dstring: [
            [/\$[a-zA-Z_]\w*/, 'variable.php'],
            [/\\./, 'string.escape'],
            [/[^"\\$]+/, 'string.double'],
            [/"/, { token: 'string.double', next: '@pop' }],
          ],
          sstring: [
            [/\\./, 'string.escape'],
            [/[^'\\]+/, 'string.single'],
            [/'/, { token: 'string.single', next: '@pop' }],
          ],
          heredoc: [
            [/.*$/, 'string.heredoc'],
          ],
        },
      });
    } catch (_) {
      // Tokenizer kayıt hatası — sessizce geç
    }
  }

  /* 4. PHP completion provider — statik + dinamik IntelliSense */
  if (!_phpCompletionDisposable) {
    _phpCompletionDisposable = monaco.languages.registerCompletionItemProvider('php', {
      triggerCharacters: ['$', '-', '>', ':', '\\', '@'],
      provideCompletionItems: (model, position) => {
        const word = model.getWordUntilPosition(position);
        const range = {
          startLineNumber: position.lineNumber,
          endLineNumber:   position.lineNumber,
          startColumn:     word.startColumn,
          endColumn:       word.endColumn,
        };

        const lineContent = model.getLineContent(position.lineNumber);
        const textBefore = lineContent.substring(0, position.column - 1);
        const isAfterArrow = /->$/.test(textBefore);
        const isAfterDollar = /\$$/.test(textBefore) || /\$\w*$/.test(textBefore);
        const isAfterDoubleColon = /::$/.test(textBefore);

        /* ── Dinamik: koddan değişken, fonksiyon, sınıf çıkar ── */
        const code = model.getValue();
        const seen = new Set();
        const dynSuggestions = [];

        // $variables
        const varRe = /\$([a-zA-Z_]\w*)/g;
        let m;
        while ((m = varRe.exec(code)) !== null) {
          const v = m[1];
          if (!seen.has('$' + v) && v !== 'this') {
            seen.add('$' + v);
            dynSuggestions.push({
              label: '$' + v,
              kind: monaco.languages.CompletionItemKind.Variable,
              insertText: isAfterDollar ? v : '$' + v,
              range, sortText: `00_${v}`, detail: 'variable',
            });
          }
        }

        // user functions
        const fnRe = /function\s+([a-zA-Z_]\w*)\s*\(([^)]*)\)/g;
        while ((m = fnRe.exec(code)) !== null) {
          const fn = m[1];
          const params = m[2].trim();
          if (!seen.has('fn_' + fn)) {
            seen.add('fn_' + fn);
            dynSuggestions.push({
              label: fn,
              kind: monaco.languages.CompletionItemKind.Function,
              insertText: `${fn}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `01_${fn}`,
              detail: params ? `(${params})` : '()',
              documentation: `function ${fn}(${params})`,
            });
          }
        }

        // class names
        const clsRe = /(?:class|interface|trait)\s+([A-Z]\w*)/g;
        while ((m = clsRe.exec(code)) !== null) {
          const cls = m[1];
          if (!seen.has('cls_' + cls)) {
            seen.add('cls_' + cls);
            dynSuggestions.push({
              label: cls,
              kind: monaco.languages.CompletionItemKind.Class,
              insertText: cls, range, sortText: `01_${cls}`, detail: 'class',
            });
          }
        }

        // constants (define / const)
        const constRe = /(?:define\s*\(\s*['"]([A-Z_]\w*)['"]\s*,|const\s+([A-Z_]\w*)\s*=)/g;
        while ((m = constRe.exec(code)) !== null) {
          const c = m[1] || m[2];
          if (c && !seen.has('const_' + c)) {
            seen.add('const_' + c);
            dynSuggestions.push({
              label: c,
              kind: monaco.languages.CompletionItemKind.Constant,
              insertText: c, range, sortText: `01_${c}`, detail: 'constant',
            });
          }
        }

        /* ── -> sonrası: sadece $this-> bağlamında method/property öner ── */
        if (isAfterArrow) {
          const methodRe = /(?:public|protected|private)\s+(?:static\s+)?function\s+([a-zA-Z_]\w*)/g;
          const propRe = /(?:public|protected|private)\s+(?:static\s+)?\$([a-zA-Z_]\w*)/g;
          const arrowSuggestions = [];
          while ((m = methodRe.exec(code)) !== null) {
            arrowSuggestions.push({
              label: m[1], kind: monaco.languages.CompletionItemKind.Method,
              insertText: `${m[1]}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `00_${m[1]}`, detail: 'method',
            });
          }
          while ((m = propRe.exec(code)) !== null) {
            arrowSuggestions.push({
              label: m[1], kind: monaco.languages.CompletionItemKind.Property,
              insertText: m[1], range, sortText: `00_${m[1]}`, detail: 'property',
            });
          }
          if (arrowSuggestions.length > 0) return { suggestions: arrowSuggestions };
        }

        /* ── :: sonrası: static üyeler ── */
        if (isAfterDoubleColon) {
          const staticSuggestions = [
            { label: 'class', kind: monaco.languages.CompletionItemKind.Keyword, insertText: 'class', range, detail: '::class' },
          ];
          const staticMethodRe = /(?:public|protected|private)\s+static\s+function\s+([a-zA-Z_]\w*)/g;
          while ((m = staticMethodRe.exec(code)) !== null) {
            staticSuggestions.push({
              label: m[1], kind: monaco.languages.CompletionItemKind.Method,
              insertText: `${m[1]}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `00_${m[1]}`, detail: 'static method',
            });
          }
          return { suggestions: staticSuggestions };
        }

        return {
          suggestions: [
            ...dynSuggestions,
            ...PHP_KEYWORDS.map((k) => ({
              label: k, kind: monaco.languages.CompletionItemKind.Keyword,
              insertText: k, range, sortText: `10_${k}`, detail: 'keyword',
            })),
            ...PHP_SNIPPETS.map((s) => ({
              label: s.label, kind: monaco.languages.CompletionItemKind.Snippet,
              insertText: s.insert,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              documentation: s.doc, range, sortText: `11_${s.label}`, detail: 'snippet',
            })),
            ...PHP_FUNCTIONS.map((f) => ({
              label: f, kind: monaco.languages.CompletionItemKind.Function,
              insertText: `${f}($0)`,
              insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              range, sortText: `12_${f}`, detail: 'built-in function',
            })),
          ],
        };
      },
    });
  }

  /* 4. PHP formatter provider */
  if (!_phpFormatterDisposable) {
    _phpFormatterDisposable = monaco.languages.registerDocumentFormattingEditProvider('php', {
      provideDocumentFormattingEdits(model) {
        return [{ range: model.getFullModelRange(), text: formatPhpCode(model.getValue()) }];
      },
    });
  }
}

/* ── Format sonrası marker temizle ── */
export function clearEditorMarkers(editor, monaco) {
  const model = editor.getModel();
  if (!model) return;
  const clear = () =>
    ['php', 'javascript', 'typescript', 'html', 'css', 'owner', ''].forEach((o) =>
      monaco.editor.setModelMarkers(model, o, []),
    );
  clear();
  model.onDidChangeContent(() => setTimeout(clear, 150));
}

/* ── PHP formatter ── */
function transformOutsideStrings(line, fn) {
  let result = '';
  let i = 0;
  let segment = '';
  while (i < line.length) {
    const ch = line[i];
    if ((ch === '/' && line[i + 1] === '/') || ch === '#') {
      result += fn(segment) + line.slice(i);
      return result;
    }
    if (ch === '"' || ch === "'") {
      result += fn(segment);
      segment = '';
      const quote = ch;
      let str = ch;
      i++;
      while (i < line.length) {
        const sc = line[i];
        str += sc;
        if (sc === '\\') { i++; if (i < line.length) str += line[i]; }
        else if (sc === quote) break;
        i++;
      }
      result += str;
    } else {
      segment += ch;
    }
    i++;
  }
  result += fn(segment);
  return result;
}

function prettifySegment(s) {
  s = s.replace(/,(?=[^\s])/g, ', ');
  s = s.replace(/\b(if|else\s+if|while|for|foreach|switch|return|echo|print|function)\s*\(/g,
    (_, kw) => `${kw.trim()} (`);
  s = s.replace(/\)\s*\{/g, ') {');

  const PLACEHOLDER = '\x00';
  const COMPOUNDS = ['->', '=>', '::', '++', '--', '**', '!==', '===', '!=', '==', '>=', '<=', '+=', '-=', '*=', '/=', '%=', '.='];
  const saved = [];
  COMPOUNDS.forEach((op) => {
    s = s.replace(new RegExp(op.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), () => {
      saved.push(op);
      return `${PLACEHOLDER}${saved.length - 1}${PLACEHOLDER}`;
    });
  });
  s = s.replace(/([^\s!<>=])=([^\s>])/g, '$1 = $2');
  s = s.replace(/([^\s])(\&\&|\|\|)([^\s])/g, '$1 $2 $3');
  s = s.replace(/([^\s\.])\.([^\s\.])/g, '$1 . $2');
  s = s.replace(new RegExp(`${PLACEHOLDER}(\\d+)${PLACEHOLDER}`, 'g'), (_, idx) => saved[parseInt(idx, 10)]);
  s = s.replace(/([^\s]) {2,}/g, '$1 ');
  return s;
}

function preprocess(code) {
  const lines = code.split('\n');
  const out = [];
  for (let i = 0; i < lines.length; i++) {
    const cur = lines[i].trim();
    if (/^}[;]?$/.test(cur)) {
      let j = i + 1;
      while (j < lines.length && lines[j].trim() === '') j++;
      if (j < lines.length) {
        const next = lines[j].trim();
        if (/^(else\b|elseif\b|else\s+if\b|catch\b|finally\b)/.test(next)) {
          out.push(`} ${next.replace(/^\}?\s*/, '')}`);
          i = j;
          continue;
        }
      }
    }
    out.push(lines[i]);
  }
  return out.join('\n')
    .replace(/\}\s*else\s*\{/g, '} else {')
    .replace(/\}\s*else\s+if\s*\(/g, '} else if (')
    .replace(/\}\s*elseif\s*\(/g, '} elseif (')
    .replace(/\}\s*catch\s*\(/g, '} catch (')
    .replace(/\}\s*finally\s*\{/g, '} finally {');
}

export function formatPhpCode(rawCode) {
  const code = preprocess(rawCode.replace(/\r\n/g, '\n').replace(/\r/g, '\n'));
  const lines = code.split('\n');
  const TAB = '    ';
  let indent = 0;
  const out = [];

  for (const raw of lines) {
    const trimmed = raw.trim();
    if (!trimmed) { out.push(''); continue; }

    const pretty = transformOutsideStrings(trimmed, prettifySegment);
    const startsWithClose = /^[}\])]/.test(pretty);
    const startsWithCase  = /^(case\b|default\s*:)/.test(pretty);

    if (startsWithClose || startsWithCase) indent = Math.max(0, indent - 1);

    out.push(TAB.repeat(indent) + pretty);

    let delta = 0;
    let inStr = false;
    let strChar = '';
    for (let i = 0; i < pretty.length; i++) {
      const ch = pretty[i];
      if (inStr) {
        if (ch === strChar && (i === 0 || pretty[i - 1] !== '\\')) inStr = false;
      } else {
        if (ch === '"' || ch === "'") { inStr = true; strChar = ch; }
        else if (ch === '{' || ch === '(' || ch === '[') delta++;
        else if (ch === '}' || ch === ')' || ch === ']') delta--;
        else if (ch === '/' && pretty[i + 1] === '/') break;
        else if (ch === '#') break;
      }
    }

    if (startsWithClose) delta += 1;
    indent = Math.max(0, indent + delta);

    if (startsWithCase && !pretty.endsWith('{')) indent++;
  }

  return out.join('\n');
}

/* ── Monaco editor varsayılan seçenekleri ── */
export const EDITOR_BASE_OPTIONS = {
  fontSize: 13,
  lineHeight: 21,
  fontFamily: "'Cascadia Code', 'Fira Code', 'JetBrains Mono', Consolas, 'Courier New', monospace",
  fontLigatures: true,
  minimap: { enabled: true, scale: 1, renderCharacters: false },
  wordWrap: 'on',
  automaticLayout: true,
  scrollBeyondLastLine: false,
  scrollBeyondLastColumn: 5,
  padding: { top: 12, bottom: 12 },
  lineNumbers: 'on',
  lineNumbersMinChars: 4,
  glyphMargin: false,
  folding: true,
  renderLineHighlight: 'gutter',
  renderWhitespace: 'none',
  matchBrackets: 'always',
  roundedSelection: true,
  selectionHighlight: true,
  occurrencesHighlight: 'singleFile',
  cursorBlinking: 'smooth',
  cursorStyle: 'line',
  cursorWidth: 2,
  smoothScrolling: true,
  mouseWheelScrollSensitivity: 1.5,
  mouseWheelZoom: true,
  quickSuggestions: { other: true, comments: false, strings: true },
  quickSuggestionsDelay: 10,
  suggestOnTriggerCharacters: true,
  acceptSuggestionOnEnter: 'on',
  acceptSuggestionOnCommitCharacter: true,
  tabCompletion: 'on',
  wordBasedSuggestions: 'currentDocument',
  suggest: {
    showKeywords: true, showSnippets: true, showFunctions: true,
    showVariables: true, showClasses: true, showMethods: true, showProperties: true,
    showConstants: true, showValues: true, showWords: true,
    insertMode: 'replace', filterGraceful: true, localityBonus: true,
    shareSuggestSelections: true, preview: true,
  },
  inlineSuggest: { enabled: true },
  parameterHints: { enabled: true, cycle: true },
  hover: { enabled: true, delay: 300 },
  'semanticHighlighting.enabled': false,
  tabSize: 4,
  insertSpaces: true,
  formatOnPaste: true,
  formatOnType: false,
  autoIndent: 'full',
  trimAutoWhitespace: true,
  dragAndDrop: true,
  links: true,
  contextmenu: true,
  overviewRulerLanes: 0,
  hideCursorInOverviewRuler: true,
  overviewRulerBorder: false,
  scrollbar: {
    vertical: 'auto', horizontal: 'auto',
    verticalScrollbarSize: 8, horizontalScrollbarSize: 8,
    useShadows: false,
  },
  bracketPairColorization: { enabled: false },
  guides: {
    bracketPairs: false, bracketPairsHorizontal: false,
    highlightActiveBracketPair: false, indentation: false,
    highlightActiveIndentation: false,
  },
  renderIndentGuides: false,
};
